/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { CheckTokenOptions, CheckTokenResponses } from '../../models/CheckToken'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Check Token
 * {@link /check-token}
 */
export function checkToken<ThrowOnError extends boolean = true>(options: Options<CheckTokenOptions, ThrowOnError> = {}): Promise<UnwrappedResult<CheckTokenResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/check-token', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<CheckTokenResponses, ThrowOnError>>
}
